import React from 'react'
import ReactDOM from 'react-dom'
import Tether from 'tether'
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import onClickOutside from 'react-onclickoutside'

class TetheredPopover extends React.Component {
  constructor (props) {
    super(props)
    this.position()
  }

  componentDidUpdate () {
    this.position()
  }

  handleClickOutside (e) {
    this.props.id && this.props.onClose && this.props.onClose(e)
  }
  position = () => {
    if (!this.props.id) return

    let {
      attachment = 'top left',
      targetAttachment = 'bottom left'
    } = this.props
    try {
      this.tether && this.tether.destroy()
      this.tether = new Tether({
        target: '#' + this.props.id,
        element: '.tethered-component',
        attachment,
        targetAttachment,
        constraints: [
          {
            to: 'window',
            attachment: 'together'
          }
        ]
      })
    } catch (e) {
      this.tether && this.tether.destroy()
      this.tether = null
    }
    this.tether && this.tether.position()
  }

  getRef = el => {
    this.el = el
  }
  animated = (c) => {
    const { duration = 300, enter = 'zoomIn', exit = 'zoomOut' } = this.props.transition || {}
    return (
      <TransitionGroup component={null}>
        <CSSTransition
          key={this.props.id + '-popover'}
          classNames={(this.props.id && {
            enter: 'animated',
            enterActive: enter,
            exit: 'animated',
            exitActive: exit
          }) || {}}
          timeout={duration}
          exit={false}
        >
          {c}
        </CSSTransition>
      </TransitionGroup>
    )
  }

  render () {
    const { duration = 300 } = this.props.transition || {}

    let style = {
      width: this.props.width,
      height: this.props.height,
      animationDuration: `${duration}ms`
    }
    const cmp = <div style={style}>{this.props.children}</div>
    if(typeof document === 'undefined') return null
    return ReactDOM.createPortal(
      <div ref={this.getRef} style={{ zIndex: '10000' }} className='tethered-component'>
        {this.animated(cmp)}
      </div>,
      document.body
    )
  }
}
export default onClickOutside(TetheredPopover)
